import type { TPredikatOrganisasiStatus } from 'types/kinerja-pelaksanaan'

export const PREDIKAT_ORGANISASI_STATUS_LABELS: Record<
  TPredikatOrganisasiStatus,
  string
> = {
  NOT_SENT: 'Pelaksanaan Belum Selesai',
  READY_TO_SEND: 'Belum Dikirim',
  SENT: 'Sudah Dikirim',
  DINAS_UNCONFIRMED: 'Kepala Sekolah belum konfirmasi data atasan',
  DINAS_REJECTED: 'Kepala Sekolah konfirmasi Anda bukan atasannya',
}
